import React from "react";
import { ReactComponent as Github } from "../assets/github-brands 1.svg";
import { ReactComponent as Mail } from "../assets/envelope-solid 1.svg";
import { ReactComponent as Linkedin } from "../assets/linkedin-brands 1.svg";
import { AiOutlineCloudDownload } from 'react-icons/ai'
import { Link } from "react-router-dom";

function Person(props) {
  return (
    <div className="about_box hover:about_box_hover rounded-3xl items-center justify-center h-[350px] w-[300px] text-white mb-14">
      <div className="text-3xl mt-4">{props.name}</div>
      <div className="text-l mb-2 mt-1">{props.position}</div>
      <div
        // list the props.picture here make it square and center the div
        className="rounded-full h-[150px] w-[150px] bg-cover bg-center m-auto"
        style={{
          backgroundImage: `url('${props.picture}')`,
          display: "flex",
          justifyContent: "center"
        }}
      ></div>
      <div>
      <a href={`mailto:${props.mail}`} target="_blank" rel="noopener noreferrer">
        <div className="text-l mt-3">{props.mail}</div>
      </a>
      </div>
      <div className="flex mt-4 justify-evenly">
        <div>
          <a href={props.github} target="_blank" rel="noopener noreferrer">
            <Github />
          </a>
        </div>
        <div>
          <a href={props.linkedin} target="_blank" rel="noopener noreferrer">
            <Linkedin />
          </a>
        </div>
      </div>
    </div>
  );
}

function About() {
  return (
    <>
      <div
        id="about"
        className="bg-white min-h-screen w-full text-center pb-12 p-5"
      >
        {/* Header Section */}
        <h1 className="pt-10 pb-10 text-center font-sans md:text-6xl text-[10vw] font-bold">
          Meet The Team
        </h1>
        <div className="md:text-3xl text-[5vw] font-normal max-w-[1400px] m-auto mb-[60px]">
          We are just a bunch of students hoping to improve the experience of
          college classes for our fellow college-mates.
        </div>

        {/* Picture Section */}
        <div className="flex justify-around flex-wrap max-w-[1400px] m-auto">
          <Person
            name="Vishal Lokare"
            position="Founder"
            picture="https://avatars.githubusercontent.com/u/31512838?v=4"
            github="https://github.com/vishal-lokare"
            mail="vish@autojoomer.co"
            linkedin="https://www.linkedin.com/in/vishal-lokare/"
          />

          <Person
            name="K. Sumanth"
            position="Front-End Developer"
            picture="https://avatars.githubusercontent.com/u/62661394?v=4"
            github="https://github.com/freak-10"
            mail="sumanth@autojoomer.co"
            linkedin="https://www.linkedin.com/in/sumanth-kotikalapudi-396b60207/"
          />

          <Person
            name="Aditya Menon"
            position="UI/UX Designer"
            picture="https://avatars.githubusercontent.com/u/25678782?v=4"
            github="https://github.com/karynaur"
            mail="adi@autojoomer.co"
            linkedin="https://www.linkedin.com/in/adityasrinivasmenon/"
          />

          <Person
            name="Nikhil Menon"
            position="Back-End Developer"
            picture="https://avatars.githubusercontent.com/u/74824711?v=4"
            github="https://github.com/nikhil9302"
            mail="nikhil@autojoomer.co"
            linkedin="https://www.linkedin.com/in/nikhil-menon-8286b9200/"
          />

          <Person
            name="Rishabh Srivastava"
            position="Maintainer"
            picture="https://avatars.githubusercontent.com/u/28211612?v=4"
            github="https://github.com/tomid9999"
            mail="rishabh@autojoomer.co"
            linkedin="https://www.linkedin.com/in/rishabh-srivastava-115490202/"
          />

          <Person
            name="Ganesh Nathan"
            position="Maintainer"
            picture="https://avatars.githubusercontent.com/u/85446331?v=4"
            github="https://github.com/Welf06"
            mail="ganesh@autojoomer.co"
            linkedin="https://www.linkedin.com/in/ganesh-nathan/"
          />

          <Person
            name="Akshay Warrier"
            position="Maintainer"
            picture="https://avatars.githubusercontent.com/u/58233418?v=4"
            github="https://github.com/AkshayWarrier"
            mail="akshay@autojoomer.co"
            linkedin="https://www.linkedin.com/in/akshay-warrier-55b5b7229/"
          />
        </div>

        {/* Footer */}
        <div className="md:text-3xl text-[5vw] font-normal max-w-[1400px] m-auto mb-[5vw] mt-[6vw] sm:mb-[60px] sm:mt-[60px]">
          What are you waiting for? Get on board and level up your offline
          college experience.
        </div>

        {/* Download Button */}
        <Link to="/download">
          <div className="bg-blue hover:bg-[#3d76c5] text-white md:text-3xl text-[5vw] font-bold p-2 rounded-lg flex-col text-center justify-center align-middle max-w-[600px] ml-auto mr-auto transition-all">
            <div className="">Download Now</div>
            <div className="max-w-[100px] ml-auto mr-auto p-1 md:text-7xl text-5xl">
              <AiOutlineCloudDownload />
            </div>
            <div className="md:text-2xl text-[4vw] font-normal">
              AutoJoomer on Play Store
            </div>
          </div>
        </Link>

        {/* <div className="md:text-2xl text-[4vw] font-semibold max-w-[1400px] m-auto mb-[6vw] mt-[6vw] sm:mb-[60px] sm:mt-[60px]">
          Made with ❤️ by AutoJoomer Maintainers and improved by Open Source
          Contributors
        </div> */}

        <br></br>
        <br></br>
        <br></br>
        <div className="md:text-xl text-[3vw] font-normal max-w-[1400px] m-auto mt-[10px]">
          Website created by Akshay and Ganesh
        </div>
      </div>
    </>
  );
}

export default About;
